import { render } from "./TherapistLpRegistration.vue?vue&type=template&id=5e46e088"
import script from "./TherapistLpRegistration.vue?vue&type=script&lang=js"
export * from "./TherapistLpRegistration.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\Euc.Web.EucCz\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__